<div class="table-filters-wrapper">
  <span *ngIf="isEditMode || selectedFilterName && (defaultConfigurationTranslation !== selectedFilterName)" class="filter-name">
    {{ selectedFilterName || '' }}<b *ngIf="filters && filters.length > 0">:</b></span>
  <span *ngFor="let filter of filters">
    <span class="filter-title" *ngIf="filter.columnSearchValue || !!filter.columnSelectedValues?.length || (filter.columnDateTimeRangeValues && (filter.columnDateTimeRangeValues.from || filter.columnDateTimeRangeValues.to))">{{ filter.displayName || '' | translate }}</span>
    <span class="filter-value" *ngIf="filter.columnSearchValue">{{ filter.columnSearchValue }}<i class="bi bi-x" (click)="clearFilter(filter)"></i></span>
    @if (filter.columnSelectedValues) {
      <span class="filter-value" *ngFor="let columnFilter of filter.columnSelectedValues">
        @if(columnFilter) {
          {{ columnFilter | datatableFilterNameDisplay: datatableDisplayAllNames }}
        }
        <i class="bi bi-x" (click)="clearFilter(filter, columnFilter)"></i>
      </span>
    }

    <span class="filter-value" *ngIf="filter.columnDateTimeRangeValues && (filter.columnDateTimeRangeValues.from || filter.columnDateTimeRangeValues.to)">
      <span *ngIf="filter.columnDateTimeRangeValues.from">{{ helperService.adjustDateFormatToUTCByAddingZ(filter.columnDateTimeRangeValues.from) | date: 'MMM dd, yyyy' }}</span>
      <span *ngIf="filter.columnDateTimeRangeValues.from && filter.columnDateTimeRangeValues.to"> - </span>
      <span *ngIf="filter.columnDateTimeRangeValues.to">{{ helperService.adjustDateFormatToUTCByAddingZ(filter.columnDateTimeRangeValues.to) | date: 'MMM dd, yyyy' }}</span>
      <i class="bi bi-x" (click)="clearFilter(filter)"></i>
    </span>
  </span>
  <span *ngIf="showSaveDatatableFilterBtn && (!isEditMode || gridSettingsChanged)" class="save-filters-btn" (click)="onSaveDatatableFilterBtnModal()">{{ 'buttons.save_filters' | translate }}</span>
  <span *ngIf="isEditMode" class="save-filters-btn" (click)="onEditDatatableFilterBtnModal()">{{ 'buttons.save_filters' | translate }}</span>
  <span *ngIf="dataTableState.gridName" class="apply-filters-btn" (click)="openApplyDatatableFilters()">{{ 'buttons.apply_saved_filters' | translate }}</span>
</div>
<div class="ngx-datatable-main-wrapper">
  <div [style.min-width.px]="dataTableMinWidth">
    <ngx-datatable *ngIf="isTableVisible"
    #table
    class="material ngx-datatable-wrapper ngx-datatable-content"
    [ngClass]="getTableClasses()"
    [rows]="rows"
    [limit]="noLimit ? undefined : dataTableState.showItemsPerPage"
    [offset]="0"
    [columnMode]="columnMode"
    [headerHeight]="headerHeight"
    [footerHeight]="rows && rows.length > 0 ? footerHeight : 0"
    [rowHeight]="rowHeight"
    [externalSorting]="useExternalApi"
    [sorts]="[dataTableState.sortingValue]"
    [scrollbarH]="true"
    (sort)="onSort($event)"
    (resize)="onResize($event)"
  >
    <ngx-datatable-column
      *ngFor="let column of columns; let customColumnData of columns;"
      [name]="column.name"
      [prop]="column.prop"
      [frozenLeft]="column.frozenLeft"
      [frozenRight]="column.frozenRight"
      [flexGrow]="column.flexGrow"
      [resizeable]="column.resizeable"
      [sortable]="column.sortable"
      [draggable]="column.draggable"
      [minWidth]="column.minWidth"
      [width]="column.width"
      [maxWidth]="column.maxWidth"
      [headerClass]="column.headerClass"
      [cellClass]="column.cellClass"
    >
      <ng-template let-column="column" ngx-datatable-header-template>
        <span [ngClass]="{'draggable': customColumnData.draggable}">
          {{ column.name | translate }}
        </span>
        <span
          id="{{column.prop}}"
          *ngIf="customColumnData?.hasFilter" class="filter-wrapper"
        >
          <i
            (click)="openDatatableFilter(column.prop, column.name, customColumnData?.showFilterSearch, customColumnData?.dataTableColumnFilters)"
            class="bi bi-filter"
            [ngClass]="{'filter-has-value': customColumnData?.isColumnFilterActive}"
          ></i>
        </span>

      </ng-template>
      <ng-template
        let-value="value"
        let-rowIndex="rowIndex"
        let-row="row"
        ngx-datatable-cell-template
      >
        <span
          *ngIf="!customColumnData?.linkedValue && !customColumnData?.richText && (!customColumnData?.inlineEditingConfig || !editedFields[rowIndex + '-' + column.prop])"
          attr.title="{{ customColumnData?.inlineEditingConfig ? ('label.click_to_edit' | translate) : value }}"
          tabindex="{{ rowIndex * 10 + 1 }}"
          (click)="customColumnData?.inlineEditingConfig ? enableEdit(rowIndex, column.prop, row, customColumnData.selectFieldKey) : null"
          [ngClass]="{'inline-cell-edit': customColumnData?.inlineEditingConfig}"
          class="{{customColumnData.highlightValue && row.externalCellClass ? row.externalCellClass : ''}}"
        >
          <i *ngIf="column?.icon" class="{{column?.icon}}"></i>
          @if(column?.fieldType === 'date') {
            {{ value ? (helperService.adjustDateFormatToUTCByAddingZ(value) | date: column?.dateFormat ?? 'MMM d, y • HH:mm') : '' }}
          } @else if(column?.fieldType === 'boolean') {
            {{ value ? ('buttons.yes' | translate) : ('buttons.no' | translate) }}
          } @else {
            {{ value }}
          }
          <span
            class="cell-placeholder"
            *ngIf="!value && customColumnData?.inlineEditingConfig && customColumnData?.inlineEditingConfig.cellPlaceholder"
          >
            {{ customColumnData?.inlineEditingConfig.cellPlaceholder | translate }}
          </span>
        </span>

        <span
          *ngIf="customColumnData?.linkedValue"
          class="linked-value"
          (click)="onLinkedValueClick(row, column.prop)"
         >
          <i *ngIf="column?.icon" class="{{column?.icon}}"></i>
          {{ value }}
        </span>

        <div
          *ngIf="customColumnData?.richText"
          class="rich-text-cell"
          [innerHTML]="value"
        ></div>

        <div
          *ngIf="
            customColumnData?.inlineEditingConfig
            && customColumnData?.inlineEditingConfig.field === inputField
            && editedFields[rowIndex + '-' + column.prop]
          "
          class="form-field-wrapper"
        >
          <ng-container
            *ngTemplateOutlet="
              inputFieldTemplate;
              context: {
                value: value,
                columnProp: column.prop,
                rowIndex: rowIndex,
                row: row,
                inputType: customColumnData?.inlineEditingConfig.type,
                placeholder: customColumnData?.inlineEditingConfig.placeholder,
              }"
          ></ng-container>
        </div>
        <div
          *ngIf="
            customColumnData?.inlineEditingConfig
            && customColumnData?.inlineEditingConfig.field === selectField
            && editedFields[rowIndex + '-' + column.prop]
          "
          class="custom-select-wrapper"
        >
          <ng-container
            *ngTemplateOutlet="
              selectFieldTemplate;
              context: {
                value: value,
                columnProp: column.prop,
                rowIndex: rowIndex,
                row: row,
                selectFieldKey: customColumnData.selectFieldKey,
                placeholder: customColumnData?.inlineEditingConfig.placeholder,
                selectConfig: customColumnData?.inlineEditingConfig?.selectConfig,
              }"
          ></ng-container>
        </div>
        <div
          *ngIf="customColumnData?.actionButtons"
          class="action-btn-wrapper"
        >
          <span
            *ngIf="customColumnData?.actionButtons.discardChanges"
            class="save-btn"
            [ngClass]="{ 'save-disabled': !row.hasChanges }"
            (click)="actionButton(row, rowIndex, dataTableActionEnum.DISCARD_CHANGES)"
            title="{{'label.discardChanges' | translate}}"
          >
            <i class="bi bi-arrow-repeat"></i>
          </span>
          <span
            *ngIf="customColumnData?.actionButtons.save"
            class="save-btn"
            [ngClass]="{ 'save-disabled': !row.saveEnabled }"
            (click)="actionButton(row, rowIndex, dataTableActionEnum.SAVE)"
            title="{{'label.save' | translate}}"
          >
            <i class="bi bi-floppy"></i>
          </span>
          <span
            *ngIf="customColumnData?.actionButtons.delete"
            class="delete-btn"
            (click)="actionButton(row, rowIndex, dataTableActionEnum.DELETE)"
            title="{{'label.delete' | translate}}"
          >
            <i class="bi bi-trash"></i>
          </span>
          <span
            *ngIf="customColumnData?.actionButtons.impersonate"
            class="impersonate-btn"
            (click)="actionButton(row, rowIndex, dataTableActionEnum.IMPERSONATE)"
            title="{{ 'label.impersonate_user' | translate }}"
        >
            <i class="bi bi-person-bounding-box"></i>
        </span>
      </div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer *ngIf="rows && rows.length > 0">
      <ng-template
        let-rowCount="rowCount"
        let-pageSize="pageSize"
        let-selectedCount="selectedCount"
        let-curPage="curPage"
        let-offset="offset"
        ngx-datatable-footer-template
      >
        <ng-container *ngIf="!hidePagination">
          <div class="page-count">{{ 'label.total_count_items' | translate: { count: useExternalApi ? totalCount : rows.length } }}</div>
          <datatable-pager
            class="datatable-pager-wrapper"
            [pagerLeftArrowIcon]="'datatable-icon-left'"
            [pagerRightArrowIcon]="'datatable-icon-right'"
            [pagerPreviousIcon]="'datatable-icon-prev'"
            [pagerNextIcon]="'datatable-icon-skip'"
            [page]="useExternalApi ? dataTableState.pageNumber : curPage"
            [size]="useExternalApi ? dataTableState.showItemsPerPage : pageSize"
            [count]="useExternalApi ? totalCount : rows.length"
            (change)="useExternalApi ? changeEvent($event, dataTableEventsChangePage) : table.onFooterPage($event)"
          >
          </datatable-pager>
          <div class="custom-select-wrapper">
            <ng-select
              [items]="itemsPerPage"
              class="custom-select-field custom-select-field__items-per-page-field"
              bindLabel="name"
              bindValue="id"
              [(ngModel)]="dataTableState.showItemsPerPage"
              [appendTo]="'body'"
              [clearable]="false"
              [searchable]="false"
              (change)="changeEvent($event, dataTableEventsChangeItemPerPage)"
            >
            </ng-select>
          </div>
          <div *ngIf="showGoToBtn" class="go-to-wrapper">
            <span>{{ 'label.go_to' | translate }}</span>
            <input type="number" />
          </div>
        </ng-container>
        <div class="submit-actions pb-0 ms-auto me-3">
          <button
              *ngIf="showExportDataBtn && exportDataApiPath"
              class="btn secondary-button primary-button__data-table"
              [ngClass]="{'me-3': showColumnsSettingsBtn}"
              (click)="downloadExportDataFile()"
            ><i class="bi bi-filetype-xlsx"></i> <span class="ms-2">{{ 'label.export_data' | translate }}</span>
          </button>
          <button
              *ngIf="showColumnsSettingsBtn"
              class="btn secondary-button primary-button__data-table"
              [ngClass]="{'me-3': showSaveBtn}"
              (click)="openDatatableColumnSettings()"
            ><i class="bi bi-gear"></i> <span class="ms-2">{{ 'label.columns_settings' | translate }}</span>
          </button>
          <button
            *ngIf="showSaveBtn"
            class="btn secondary-button primary-button__data-table"
            translate="{{'label.discard'}}"
            (click)="discardChanges()"
          ></button>
          <button
            *ngIf="showSaveBtn"
            class="btn primary-button primary-button__data-table ms-2"
            [disabled]="isSaveDisabled"
            (click)="saveDataTable()"
            translate="{{'label.save'}}"
          ></button>
        </div>
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>
  </div>
</div>

<ng-template
  #inputFieldTemplate
  let-value="value"
  let-rowIndex="rowIndex"
  let-row="row"
  let-columnProp="columnProp"
  let-inputType="inputType"
  let-placeholder="placeholder"
>
  <input
    class="form-field form-field__datatable"
    autofocus="true"
    tabindex="{{ rowIndex * 10 + 1 }}"
    type="{{ inputType || 'text' }}"
    placeholder="{{ (placeholder | translate) || '' }}"
    [value]="value"
    (blur)="updateValue($event, columnProp, rowIndex, row, true)"
    (input)="changeTableInput($event, columnProp, rowIndex, row)"
  />
</ng-template>

<ng-template
  #selectFieldTemplate
  let-selectConfig="selectConfig"
  let-value="value"
  let-placeholder="placeholder"
  let-rowIndex="rowIndex"
  let-row="row"
  let-columnProp="columnProp",
  let-selectFieldKey="selectFieldKey"
>
  <ng-select
    [items]="selectFieldKey && selectConfig?.isRelatedField ? (row[selectFieldKey] || []) : selectConfig?.items"
    class="custom-select-field"
    [bindLabel]="selectConfig?.bindLabel || 'name'"
    [bindValue]="selectConfig?.bindValue || 'id'"
    [placeholder]="(placeholder | translate) || ''"
    [appendTo]="'body'"
    [ngModel]="row.selectedValue"
    [ngModelOptions]="{standalone: true}"
    [clearable]="selectConfig?.clearable || false"
    [searchable]="selectConfig?.searchable || false"
    [addTagText]="selectConfig?.addTagText ? selectConfig?.addTagText : 'label.add_new_label' | translate"
    [addTag]="selectConfig?.addTag && enableAddSelectBtn"
    (change)="updateValue(
      $event,
      columnProp,
      rowIndex,
      row,
      false,
      selectConfig?.bindValue,
      selectFieldKey,
      (selectFieldKey && selectConfig?.isRelatedField ? (row[selectFieldKey] || []) : selectConfig?.items),
      selectConfig?.isRelatedField,
      selectConfig?.addSelectedItem
    )"
    (blur)="selectOnBlur(columnProp, rowIndex, row)"
    [searchFn]="externalSearch ? returnTrue : null"
    (search)="onSearch(
      $event,
      columnProp,
      rowIndex,
      row,
      (selectFieldKey && selectConfig?.isRelatedField ? (row[selectFieldKey] || []) : selectConfig?.items))"
    (clear)="onClear(columnProp, rowIndex, row)"
  >
  </ng-select>
</ng-template>

<app-dynamic-table-filter
  *ngIf="showDatatableFilter"
  [filtersState]="dataTableState.datatableFilters"
  [datatableSettings]="dataTableState"
  [globalSearchTerm]="globalSearchTerm"
  [datatableFilterPosition]="datatableFilterPosition"
  [filterValues]="filterValues"
  [columnProp]="columnProp"
  [columns]="columns"
  [displayName]="displayName"
  [currentFilter]="currentFilter"
  [showFilterSearch]="showFilterSearch"
  (onCloseFilter)="closeFilter()"
  (onApplyFilter)="applyFilter($event)"
  (isFilterHasValue)="filterHasValue($event)"
></app-dynamic-table-filter>

<app-dynamic-table-column-settings
  *ngIf="showDatatableColumnSettings"
  [columns]="orgColumns"
  (onCloseColumnsSettings)="closeColumnsSettings()"
  (onApplyColumnsSettings)="applyColumnsSettings($event)"
></app-dynamic-table-column-settings>

<ng-template #saveFiltersContent>
  <div class="modal-filters-wrapper">

    <div class="filters-list">
      <div *ngFor="let filter of tempFilters" class="filter-item">

        <div class="filter-row">
          <span class="filter-title">
            {{ filter.displayName || '' | translate }}
          </span>

          <span class="filter-value pe-2">
            {{ filter.columnSearchValue || (filter.columnSelectedValues?.join(', ') || '') }}
            <span *ngIf="filter.columnDateTimeRangeValues && (filter.columnDateTimeRangeValues.from || filter.columnDateTimeRangeValues.to)">
              {{ filter.columnDateTimeRangeValues.from ? (helperService.adjustDateFormatToUTCByAddingZ(filter.columnDateTimeRangeValues.from) | date: 'MMM dd, yyyy') : '' }}
              <span *ngIf="filter.columnDateTimeRangeValues.from && filter.columnDateTimeRangeValues.to"> - </span>
              {{ filter.columnDateTimeRangeValues.to ? (helperService.adjustDateFormatToUTCByAddingZ(filter.columnDateTimeRangeValues.to) | date: 'MMM dd, yyyy') : '' }}
            </span>
          </span>
        </div>

      </div>
    </div>

    <app-input-form-field
      [(ngModel)]="savedFilterName"
      [label]="'label.filter_name' | translate"
      [placeholder]="'placeholders.enter_filter_name' | translate"
      (ngModelChange)="updateSaveButtonState()"
    ></app-input-form-field>

    <app-checkbox-form-field
      *ngIf="isAdmin"
      [(ngModel)]="saveAsGlobal"
      [label]="'label.global_check' | translate"
    ></app-checkbox-form-field>
  </div>
</ng-template>


<ng-template #applyFiltersContent>
  <div class="apply-filters-wrapper">
    <div *ngIf="selectedFilterName && !showSaveDatatableFilterBtn" class="mb-3">{{ 'label.applied_filter' | translate }}: <span class="fw-bold">{{ selectedFilterName }}</span></div>
    <ngx-datatable
      #table
      class="material ngx-datatable-wrapper ngx-datatable-wrapper-filters ngx-datatable-sticky-header"
      [rows]="savedFilters"
      [offset]="0"
      [columnMode]="columnMode"
      [headerHeight]="headerHeight"
      [footerHeight]="footerHeight"
      [rowHeight]="rowHeight"
    >
      <ngx-datatable-column
        name="{{ 'label.filters' | translate }}"
        prop="name"
        [flexGrow]="1"
        [sortable]="false"
        [draggable]="false"
      >
        <ng-template let-value="value" let-column="column" let-row="row" ngx-datatable-cell-template>
          <span class="value-badge">
            <span>          <span
            class="filter-title me-2 filter-icon"
            title="{{ row.isGlobal ? ('label.global_filter_title' | translate) : ('label.user_filter_title' | translate) }}"
          >
            @if(row.isGlobal) {
              <i class="bi bi-globe"></i>
            } @else {
              <i class="bi bi-person-circle"></i>
            }
          </span>
          {{ value }}</span>
          @if(row.isGlobal && row.id > 0 && ((!isAdmin && row.isDefault) || isAdmin)) {
            <span class="badge default-badge" title="{{ 'label.click_to_set_as_default' | translate }}" (click)="setDefaultFilter(row)" [ngClass]="{'default-badge--inactive' : !row.isDefault, 'default-badge--forbidden' : !isAdmin }">{{ 'label.default' | translate }}</span>
          }
          </span>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [flexGrow]="1"
        name="{{ 'label.actions' | translate }}"
        [sortable]="false"
        [draggable]="false"
        [maxWidth]="120"
        [headerClass]="'text-center'"
      >
        <ng-template ngx-datatable-cell-template let-row="row">
          <div
            class="manage-filters"          >
            <i class="bi bi-check-circle-fill apply-btn" title="{{ 'label.apply_filter' | translate }}" (click)="selectSavedFilter(row, false)"></i>
            <i class="bi bi-pencil apply-btn" title="{{ 'label.edit_filter' | translate }}" *ngIf="(!row.isGlobal || isAdmin) && row.id > 0" (click)="selectSavedFilter(row, true)"></i>
            <i class="bi bi-trash apply-btn" title="{{ 'label.delete_filter' | translate }}" *ngIf="!row.isGlobal || isAdmin && row.id > 0" (click)="deleteSavedFilter(row)"></i>
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-footer *ngIf="savedFilters && savedFilters.length > 0">
        <ng-template ngx-datatable-footer-template >
          <ng-container>
            <div class="page-count">{{ 'label.total_count_items' | translate: { count: savedFiltersTotalCount } }}</div>
            <datatable-pager
              class="datatable-pager-wrapper"
              [pagerLeftArrowIcon]="'datatable-icon-left'"
              [pagerRightArrowIcon]="'datatable-icon-right'"
              [pagerPreviousIcon]="'datatable-icon-prev'"
              [pagerNextIcon]="'datatable-icon-skip'"
              [page]="savedFiltersDataTableState.pageNumber"
              [size]="savedFiltersDataTableState.showItemsPerPage"
              [count]="savedFiltersTotalCount"
              (change)="savedFiltersChangeEvent($event, dataTableEventsChangePage)"
            >
            </datatable-pager>
            <div class="custom-select-wrapper">
              <ng-select
                [items]="savedFiltersItemsPerPage"
                class="custom-select-field custom-select-field__items-per-page-field custom-select-field-modal"
                bindLabel="name"
                bindValue="id"
                [(ngModel)]="savedFiltersDataTableState.showItemsPerPage"
                [appendTo]="'body'"
                [clearable]="false"
                [searchable]="false"
                (change)="savedFiltersChangeEvent($event, dataTableEventsChangeItemPerPage)"
              >
              </ng-select>
            </div>
          </ng-container>
        </ng-template>
      </ngx-datatable-footer>
    </ngx-datatable>
  </div>
</ng-template>
